<template>
    <div class="main-layout">
        <!-- 侧边栏 -->
        <aside class="sidebar">
            <!-- Logo 区域 -->
            <div class="sidebar-logo">
                <div class="logo-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10"/>
                        <path d="m9 12 2 2 4-4"/>
                    </svg>
                </div>
                <span class="logo-text">溯源系统</span>
            </div>

            <!-- 导航菜单 -->
            <nav class="sidebar-nav">
                <div class="nav-group-title">主菜单</div>
                <div
                    v-for="(item, index) in menu"
                    :key="item.name || index"
                >
                    <template v-if="item.children">
                        <div
                            class="nav-submenu"
                            :class="{ 'nav-submenu-active': isSubmenuActive(item) }"
                        >
                            <div
                                class="nav-submenu-title"
                                @click="toggleSubmenu(item)"
                            >
                                <span>{{ item.title }}</span>
                                <svg class="submenu-arrow" :class="{ 'arrow-rotated': openNames.includes(item.name) }" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <polyline points="9 18 15 12 9 6"/>
                                </svg>
                            </div>
                            <div class="nav-submenu-items" v-show="openNames.includes(item.name)">
                                <div
                                    v-for="(child, i) in item.children"
                                    :key="child.name || i"
                                    class="nav-item"
                                    :class="{ 'nav-item-active': String($route.name) === String(child.name) }"
                                    @click="goTo(child)"
                                >
                                    <span>{{ child.title }}</span>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div
                            class="nav-item"
                            :class="{ 'nav-item-active': String($route.name) === String(item.name) }"
                            @click="goTo(item)"
                        >
                            <span>{{ item.title }}</span>
                        </div>
                    </template>
                </div>

                <div class="nav-group-title" style="margin-top: 32px;">设置与支持</div>
                <div 
                    v-for="(item, idx) in sys_menu" :key="item.name || idx">
                    
                    <template v-if="item.children">
                        <div
                            class="nav-submenu"
                            :class="{ 'nav-submenu-active': isSubmenuActive(item) }"
                        >
                            <div
                                class="nav-submenu-title"
                                @click="toggleSubmenu(item)"
                            >
                                <span>{{ item.title }}</span>
                                <svg class="submenu-arrow" :class="{ 'arrow-rotated': openNames.includes(item.name) }" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <polyline points="9 18 15 12 9 6"/>
                                </svg>
                            </div>
                            <div class="nav-submenu-items" v-show="openNames.includes(item.name)">
                                <div
                                    v-for="(child, i) in item.children"
                                    :key="child.name || i"
                                    class="nav-item"
                                    :class="{ 'nav-item-active': String($route.name) === String(child.name) }"
                                    @click="goTo(child)"
                                >
                                    <span>{{ child.title }}</span>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div
                            class="nav-item"
                            :class="{ 'nav-item-active': String($route.name) === String(item.name) }"
                            @click="goTo(item)"
                        >
                                <span>{{ item.title }}</span>
                        </div>
                    </template>
                    
                </div>
            </nav>

            <!-- 底部信息 -->
            <div class="sidebar-footer">
            
                <div class="logout-btn" @click="goLogout">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                        <polyline points="16 17 21 12 16 7"/>
                        <line x1="21" y1="12" x2="9" y2="12"/>
                    </svg>
                    <span>退出登录</span>
                </div>
            </div>
        </aside>

        <!-- 主内容区 -->
        <div class="main-container">
            <!-- 顶部栏 -->
            <header class="top-header">
                <!-- 搜索框 -->
                <div class="search-box">
                  
                </div>

                <div class="header-right">
                    <!-- 通知按钮 -->
                    <!-- <div class="header-icon-btn" @click="goModal(1)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/>
                            <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"/>
                        </svg>
                        <span class="notification-dot"></span>
                    </div> -->

                    <div class="header-divider"></div>

                    <!-- 用户信息 -->
                    <div class="user-info" @click="goModal()" style="cursor: pointer;">
                        <div class="user-text">
                            <div class="user-name">{{ user }}</div>
                            <div class="user-role">高级管理员</div>
                        </div>
                        <div class="user-avatar">
                            {{ user ? user.charAt(0) : 'U' }}
                        </div>
                    </div>
                </div>
            </header>

            <!-- 内容区域 -->
            <main class="content-area">

                <!-- 页面内容 -->
                <router-view></router-view>
                
                <!-- 底部系统支持 -->
                <div class="system-support-footer">系统支持 | 商乔科技</div>
            </main>
        </div>

        <!-- 账户信息 -->
        <Modal v-model="modals" width="500" :mask-closable="false">
            <div slot="header">
                <div class="modal-header">账户信息</div>
            </div>
            <div>
                    <Form :model="formItem" label-position="right" :label-width="100" :rules="ruleValidate">
                        <FormItem label="姓名:" prop="user">
                            <Input type="text" v-model="formItem.user" placeholder="请输入账户名称"></Input>
                        </FormItem>
                        <FormItem label="登录密码:">
                            <Input type="password" v-model="formItem.password" placeholder="请输入登录密码"></Input>
                        </FormItem>
                        <FormItem label="手机号:" prop="phone">
                            <Input type="text" disabled v-model="formItem.phone" placeholder="请输入手机号"></Input>
                        </FormItem>
                    </Form>
            </div>
            <template slot="footer">
                <Button @click="removeModal">取消</Button>
                <Button class="theme-bc theme-default-color" @click="submitModal">保存</Button>
            </template>
        </Modal>


    </div>
</template>

<script>

import { windowsRise } from "@/utils/dom";
import { removeCookies, getStorages, setStorages } from "@/utils/helper";
import ContactButton from "@/components/ContactButton/ContactButton.vue";
import { logout, other_citys, account_modify_info } from "@/api/index";
export default {
    components: { ContactButton },
    data() {
        return {
            imageValue: "",
            innerHeight: 0,
            diy_id: 0,
            user: "",
            phone: "",
            id: "",
            admin_id: "",
            openNames: [],
            modals: false,
            infos:{},
            formItem: {
                user: "",
                password: "",
                phone: "",
            },
            ruleValidate: {
                user: [{ required: false, message: "请输入账户名称", trigger: "blur" }],
                phone: [{ required: false, message: "请输入手机号", trigger: "blur" }],
            },
            tip_value: false,
        };
    },
    metaInfo: {
        title: "首页",
        meta: [
            { name: "viewport", content: "width=device-width,user-scalable=yes,initial-scale=0.3,minimum-scale=0.3,maximum-scale=2" },
        ],
    },
    computed: {
        menu() {
            return this.$store.state.menus.menus;
        },
        sys_menu() {
            return this.$store.state.menus.special_children;
        },
    },
    created() {
        this.infos = getStorages("infos");
        this.user = this.infos.account || this.infos.phone;
        this.phone = this.infos.phone;
        this.id =  this.infos.id;
        this.admin_id = this.infos.admin_id;
        if (!localStorage.getItem("cityList")) {
            this.getCity();
        }
        if (this.infos.tips_path) {
            this.tip_value = true;
        }
    },
    mounted() {
        this.restHeight();
        windowsRise(window, this.restHeight);
        this.selectMenu();
    },
    watch: {
        "$route.path"() {
            this.selectMenu();
        },
        $route: {
            handler(to, from) {
            },
            immediate: true,
        },
    },
    methods: {
        currentImage(item) {
            if (this.imageValue == item.name) {
                return item.select_icon;
            } else {
                return item.name == this.$route.name ? item.select_icon : item.icon;
            }
        },
        changeImage(item) {
            this.imageValue = item.name;
        },
        resetImage() {
            this.imageValue = "";
        },
        isSubmenuActive(item) {
            if (!item.children) return false;
            return item.children.some(child => child.name == this.$route.name);
        },
        toggleSubmenu(item) {
            const index = this.openNames.indexOf(item.name);
            if (index > -1) {
                this.openNames = this.openNames.filter(name => name !== item.name);
            } else {
                this.openNames.push(item.name);
            }
        },
        goTo(item) {
            this.$router.push({ path: item.path });
        },
        getCity() {
            other_citys().then((res) => {
                localStorage.setItem("cityList", JSON.stringify(res.data));
            });
        },

        restHeight() {
            this.innerHeight = window.innerHeight;
        },
        selectMenu() {
            if (this.$route.query.diy_id) {
                this.diy_id = this.$route.query.diy_id;
                return;
            }
            this.diy_id = 0;
            const routeName = this.$route.name;
            if (!routeName) {
                this.openNames = [];
                return;
            }
            // 合并主菜单和设置菜单，查找当前路由是否属于某个父菜单的子项
            const allMenus = [...this.menu, ...this.sys_menu];
            const parentMenu = allMenus.find(
                (item) => item.children && item.children.some((child) => String(child.name) === String(routeName))
            );
            if (parentMenu) {
                // 当前路由是子菜单项，展开对应父菜单
                this.openNames = [parentMenu.name];
            }
            // 扁平菜单项：不修改 openNames，保持用户手动展开/收起的状态
        },
        goLogout() {
            logout()
                .then((res) => {
                    this.$Message.success(res.msg);
                    localStorage.clear();
                    removeCookies("p_c_access_token");
                    this.$router.push({ path: "/" });
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        goModal() {
                this.formItem.user = this.user;
                this.formItem.phone = this.phone;
                this.modals = true;
        },
        removeModal() {
            this.modals = false;
        },
        submitModal() {
            account_modify_info(this.formItem)
                .then((res) => {
                    this.modals = false;
                    this.goLogout();
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        goAssembly() {
            this.$router.push({ path: "/admin/assembly" });
        },
        closeTips() {
            this.clearTipsPath();
            this.tip_value = false;
        },
        openTips() {
            this.clearTipsPath();
            window.open(this.infos.tips_link);
        },
        clearTipsPath(){
            this.infos.tips_path = ""
            setStorages('infos', this.infos);
        }
    },
};
</script>

<style scoped>
/* 主布局 */
.main-layout {
    display: flex;
    min-height: 100vh;
    background: #f8fafc;
}

/* 侧边栏 */
.sidebar {
    width: 256px;
    background: #ffffff;
    border-right: 1px solid #e2e8f0;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    position: fixed;
    height: 100vh;
    z-index: 100;
}

/* Logo */
.sidebar-logo {
    padding: 24px;
    display: flex;
    align-items: center;
    gap: 12px;
}

.logo-icon {
    width: 32px;
    height: 32px;
    background: linear-gradient(135deg, #2563eb 0%, #3b82f6 100%);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
}

.logo-text {
    font-size: 20px;
    font-weight: 800;
    color: #0f172a;
    letter-spacing: -0.5px;
}

/* 导航菜单 */
.sidebar-nav {
    flex: 1;
    padding: 0 16px 16px;
    overflow-y: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
}

/* 隐藏 Webkit 浏览器的滚动条 */
.sidebar-nav::-webkit-scrollbar {
    display: none;
}

.nav-group-title {
    font-size: 10px;
    font-weight: 800;
    color: #94a3b8;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    margin-bottom: 16px;
    padding: 0 8px;
}

.nav-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.2s ease;
    color: #64748b;
    font-weight: 600;
    font-size: 14px;
    position: relative;
    margin-bottom: 4px;
}

.nav-item:hover {
    background: #eff6ff;
    color: #2563eb;
}

.nav-item-active {
    background: linear-gradient(135deg, #2563eb 0%, #3b82f6 100%);
    color: #ffffff;
    box-shadow: 0 4px 12px rgba(37, 99, 235, 0.25);
}

.nav-item-active:hover {
    background: linear-gradient(135deg, #2563eb 0%, #3b82f6 100%);
    color: #ffffff;
}

.nav-item-arrow {
    margin-left: auto;
}

.nav-icon {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
}

.news-badge {
    margin-left: auto;
    background: #ef4444;
    color: #ffffff;
    font-size: 10px;
    font-weight: 700;
    padding: 2px 6px;
    border-radius: 10px;
    min-width: 20px;
    text-align: center;
}

/* 子菜单 */
.nav-submenu {
    margin-bottom: 4px;
}

.nav-submenu-title {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.2s ease;
    color: #64748b;
    font-weight: 600;
    font-size: 14px;
}

.nav-submenu-title:hover {
    background: #eff6ff;
    color: #2563eb;
}

.nav-submenu-active > .nav-submenu-title {
    color: #2563eb;
    background: #eff6ff;
}

.submenu-arrow {
    margin-left: auto;
    transition: transform 0.2s ease;
}

.arrow-rotated {
    transform: rotate(90deg);
}

.nav-submenu-items {
    padding-left: 15px;
    margin-top: 4px;
}

.nav-submenu-items .nav-item {
    padding: 10px 16px;
    font-size: 13px;
}

/* 侧边栏底部 */
.sidebar-footer {
    padding: 16px;
    margin-top: auto;
}

.version-card {
    background: #f8fafc;
    border-radius: 16px;
    padding: 16px;
    margin-bottom: 12px;
    border: 1px solid #e2e8f0;
}

.version-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
}

.version-dot {
    width: 8px;
    height: 8px;
    background: #10b981;
    border-radius: 50%;
    animation: pulse 2s infinite;
}

@keyframes pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.5; }
}


.logout-btn {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.2s ease;
    color: #64748b;
    font-weight: 700;
    font-size: 14px;
}

.logout-btn:hover {
    background: #fef2f2;
    color: #dc2626;
}

/* 主容器 */
.main-container {
    flex: 1;
    margin-left: 256px;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    transition: margin-left 0.3s ease;
}

/* 顶部栏 */
.top-header {
    height: 80px;
    background: #ffffff;
    border-bottom: 1px solid #e2e8f0;
    padding: 0 32px;
    display: flex;
    align-items: center;
    position: sticky;
    top: 0;
    z-index: 20;
}

.search-box {
    width: 384px;
    position: relative;
}

.search-box svg {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #94a3b8;
}

.search-box input {
    width: 100%;
    background: #f1f5f9;
    border: none;
    border-radius: 12px;
    padding: 10px 16px 10px 40px;
    font-size: 14px;
    font-weight: 500;
    color: #0f172a;
    outline: none;
    transition: all 0.2s ease;
}

.search-box input:focus {
    background: #ffffff;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.search-box input::placeholder {
    color: #94a3b8;
}

.header-right {
    margin-left: auto;
    display: flex;
    align-items: center;
    gap: 16px;
}

.header-icon-btn {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.2s ease;
    color: #64748b;
    border: 1px solid #e2e8f0;
    position: relative;
}

.header-icon-btn:hover {
    background: #f1f5f9;
    color: #2563eb;
}

.notification-dot {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 8px;
    height: 8px;
    background: #ef4444;
    border-radius: 50%;
    border: 2px solid #ffffff;
}

.header-divider {
    width: 1px;
    height: 32px;
    background: #e2e8f0;
}

.user-info {
    display: flex;
    align-items: center;
    gap: 12px;
}

.user-text {
    text-align: right;
}

.user-name {
    font-size: 14px;
    font-weight: 700;
    color: #0f172a;
}

.user-role {
    font-size: 10px;
    font-weight: 700;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}

.user-avatar {
    width: 40px;
    height: 40px;
    background: linear-gradient(135deg, #2563eb 0%, #4f46e5 100%);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-weight: 700;
    font-size: 14px;
    box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
}

/* 内容区域 */
.content-area {
    padding: 32px;
    flex: 1;
    display: flex;
    flex-direction: column;
}

/* 底部系统支持 */
.system-support-footer {
    text-align: center;
    font-size: 12px;
    font-weight: 500;
    color: #94a3b8;
    padding: 16px 0 8px;
    margin-top: auto;
}

/* 面包屑卡片 */
.breadcrumb-card {
    background: #ffffff;
    border-radius: 16px;
    padding: 24px;
    margin-bottom: 24px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    border: 1px solid #e2e8f0;
}

.breadcrumb-content {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #64748b;
}

.breadcrumb-tip {
    margin-top: 12px;
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.breadcrumb-tip-txt {
    font-weight: 400;
    font-size: 14px;
    color: #2563eb;
    margin-right: 10px;
}

/* 原有样式保留 */
.wh16 {
    width: 16px;
    height: 16px;
}
.detail_header {
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 14px;
    color: #484e66;
}
.width_22 {
    width: 22px;
    height: 22px;
}
.detail_content {
    margin: 24px 0;
    display: flex;
    flex-direction: row;
    align-content: center;
    justify-content: space-around;
}
.detail_div {
    margin-top: 5px;
    display: flex;
    flex-direction: row;
    align-items: center;
}
.detail_left {
    margin-right: 24px;
    width: 110px;
    text-align: right;
}
.page_div {
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
}
.flex-sb {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 16px;
}
.flex-sa {
    display: flex;
    align-items: center;
    gap: 8px;
}
.flex-c {
    display: flex;
    align-items: center;
}
.mr24 {
    margin-right: 24px;
}
.ml24 {
    margin-left: 24px;
}
.ml6 {
    margin-left: 6px;
}
.mt24 {
    margin-top: 24px;
}
.mb12 {
    margin-bottom: 12px;
}
.w200 {
    width: 200px;
}
.mr12 {
    margin-right: 12px;
}
.mt24 {
    margin-top: 24px;
}
.ta-r {
    text-align: right;
}
.ta-l {
    text-align: left;
}
.modal-header {
    padding: 16px 20px;
    font-size: 16px;
    font-weight: 700;
    color: #0f172a;
    border-bottom: 1px solid #e2e8f0;
}
.modal-box {
    padding-bottom: 0 !important;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.modal-btn {
    display: flex;
    flex-direction: row;
}
.read-all-btn {
    color: #64748b;
}
.search-btn {
    order: 1;
}
.theme-color {
    color: #2563eb;
}
.theme-bc {
    background: linear-gradient(135deg, #2563eb 0%, #3b82f6 100%) !important;
    color: #ffffff !important;
    border: none !important;
}
.theme-default-color {
    color: #ffffff;
}
.theme-bc:hover {
    background: linear-gradient(135deg, #1d4ed8 0%, #2563eb 100%);
}

/* 响应式 */
@media (max-width: 1300px) {
    .modal-btn {
        flex-direction: column;
    }
    .read-all-btn {
        order: 2;
    }
    .search-btn {
        order: 1;
    }
}

::v-deep .ivu-modal-header {
    padding: 0px;
}
::v-deep .ivu-modal-header-inner {
    font-weight: 700;
    color: #0f172a;
}
::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: #2563eb;
    background-color: #2563eb;
}
::v-deep .ivu-btn-success {
    color: #16a34a;
    border-color: #16a34a;
}
::v-deep .ivu-btn-error {
    color: #dc2626;
    border-color: #dc2626;
}
::v-deep .ivu-table th {
    background: #f8fafc !important;
    color: #64748b !important;
    font-weight: 700 !important;
}
::v-deep .ivu-breadcrumb-item-link {
    color: #64748b;
}
::v-deep .ivu-breadcrumb-item-link:hover {
    color: #2563eb;
}
</style>
